import React from 'react';
import styled from '@emotion/styled';
import { EmotionBreakpoint } from 'dw-us-ui';
import { useCaseBuilderContext } from '../../context/CaseBuilderContext';
import SwapIcon from '../../../../icons/SwapIcon';

const WineVisualList = styled.div`
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
`;

const WineBottleItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: center;
	flex-shrink: 0;
	cursor: pointer;
	position: relative;

	${EmotionBreakpoint('mobile')} {
		scroll-snap-align: center;
	}

	${EmotionBreakpoint('tablet')} {
		scroll-snap-align: center;
	}

	svg {
		${EmotionBreakpoint('mobile')} {
			display: none;
		}
	}
`;

const BottleImageContainer = styled.div`
	transition: opacity 0.3s ease;
	opacity: ${({ active }) => (active ? 1 : 0.3)};
`;

const BottleImage = styled.img`
	width: auto;
	max-height: 198px;
	max-width: 44px;
	object-fit: contain;

	${EmotionBreakpoint('mobile')} {
		max-height: 70px;
	}
	${EmotionBreakpoint('tablet')} {
		max-height: 170px;
	}
`;

const WineList = () => {
	const { wineSlots, activeBottleIndex, handleBottleClick, handleBottleSwap } =
		useCaseBuilderContext();

	if (wineSlots.length === 0) {
		return <div>No offers available at this time.</div>;
	}

	return (
		<WineVisualList>
			{wineSlots.slice(0, 12).map((wineData, index) => (
				<WineBottleItem
					key={`bottle-${wineData?.product?.itemCode}-${index}`}
					onClick={() => handleBottleClick(wineData?.product, index)}
				>
					<BottleImageContainer active={index === activeBottleIndex}>
						<BottleImage
							src={
								`/images/us/en/product/${wineData?.product?.itemCode}.png` ||
								'/images/us/common/default_bottle_small.png'
							}
							alt={wineData?.product?.name || 'Wine bottle'}
							onError={(e) => {
								e.currentTarget.onerror = null;
								e.currentTarget.src =
									'/images/us/common/default_bottle_small.png';
							}}
						/>
					</BottleImageContainer>
					<SwapIcon
						onClick={(e) => {
							e.stopPropagation();
							handleBottleSwap(index);
						}}
					/>
				</WineBottleItem>
			))}
		</WineVisualList>
	);
};

export default WineList;
